import { useQuery } from "@tanstack/react-query";
import { GET_COURSE_TASK_LIST, getCourseTaskList } from "..";

export const useCourseTaskListQuery = ({
  load = false,
  programId = "",
  courseId = "",
  studentBatchId = "",
}) => {
  return useQuery({
    queryKey: [GET_COURSE_TASK_LIST, programId, courseId, studentBatchId],
    queryFn: () => getCourseTaskList(programId, courseId, studentBatchId),
    enabled: !!programId && !!courseId && !!studentBatchId && load,
    refetchOnWindowFocus: true,
  });
};
